import { useAuth } from '../../../components/AuthContext/context';

export const useAccountUid = () => {
  const { session } = useAuth();
  const accountUid = `${session?.exchange_session?.user.account_uid}`;
  return accountUid;
};
